import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent  {

  @Input() title = '';
  @Input() title2 = '';
  @Input() diameter!: string

  templateSuffix = environment.templateSuffix;
  getDiameter(){
    if(this.diameter)
      return {
        height: this.diameter,
        width: this.diameter,
      }
    return null
  }

}
